/**
 * @fileoverview gRPC-Web generated client stub for chatcontext
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: chatcontext/chatcontext.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.chatcontext = require('./chatcontext_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.chatcontext.ChatContextServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.chatcontext.ChatContextServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chatcontext.GetChatContextRequest,
 *   !proto.chatcontext.GetChatContextResponse>}
 */
const methodDescriptor_ChatContextService_GetChatContext = new grpc.web.MethodDescriptor(
  '/chatcontext.ChatContextService/GetChatContext',
  grpc.web.MethodType.UNARY,
  proto.chatcontext.GetChatContextRequest,
  proto.chatcontext.GetChatContextResponse,
  /**
   * @param {!proto.chatcontext.GetChatContextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chatcontext.GetChatContextResponse.deserializeBinary
);


/**
 * @param {!proto.chatcontext.GetChatContextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chatcontext.GetChatContextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chatcontext.GetChatContextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chatcontext.ChatContextServiceClient.prototype.getChatContext =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chatcontext.ChatContextService/GetChatContext',
      request,
      metadata || {},
      methodDescriptor_ChatContextService_GetChatContext,
      callback);
};


/**
 * @param {!proto.chatcontext.GetChatContextRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chatcontext.GetChatContextResponse>}
 *     Promise that resolves to the response
 */
proto.chatcontext.ChatContextServicePromiseClient.prototype.getChatContext =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chatcontext.ChatContextService/GetChatContext',
      request,
      metadata || {},
      methodDescriptor_ChatContextService_GetChatContext);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chatcontext.UpdateChatContextRequest,
 *   !proto.chatcontext.UpdateChatContextResponse>}
 */
const methodDescriptor_ChatContextService_UpdateChatContext = new grpc.web.MethodDescriptor(
  '/chatcontext.ChatContextService/UpdateChatContext',
  grpc.web.MethodType.UNARY,
  proto.chatcontext.UpdateChatContextRequest,
  proto.chatcontext.UpdateChatContextResponse,
  /**
   * @param {!proto.chatcontext.UpdateChatContextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chatcontext.UpdateChatContextResponse.deserializeBinary
);


/**
 * @param {!proto.chatcontext.UpdateChatContextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chatcontext.UpdateChatContextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chatcontext.UpdateChatContextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chatcontext.ChatContextServiceClient.prototype.updateChatContext =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chatcontext.ChatContextService/UpdateChatContext',
      request,
      metadata || {},
      methodDescriptor_ChatContextService_UpdateChatContext,
      callback);
};


/**
 * @param {!proto.chatcontext.UpdateChatContextRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chatcontext.UpdateChatContextResponse>}
 *     Promise that resolves to the response
 */
proto.chatcontext.ChatContextServicePromiseClient.prototype.updateChatContext =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chatcontext.ChatContextService/UpdateChatContext',
      request,
      metadata || {},
      methodDescriptor_ChatContextService_UpdateChatContext);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chatcontext.GetSourcesTotalsRequest,
 *   !proto.chatcontext.GetSourcesTotalsResponse>}
 */
const methodDescriptor_ChatContextService_GetSourcesTotals = new grpc.web.MethodDescriptor(
  '/chatcontext.ChatContextService/GetSourcesTotals',
  grpc.web.MethodType.UNARY,
  proto.chatcontext.GetSourcesTotalsRequest,
  proto.chatcontext.GetSourcesTotalsResponse,
  /**
   * @param {!proto.chatcontext.GetSourcesTotalsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chatcontext.GetSourcesTotalsResponse.deserializeBinary
);


/**
 * @param {!proto.chatcontext.GetSourcesTotalsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chatcontext.GetSourcesTotalsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chatcontext.GetSourcesTotalsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chatcontext.ChatContextServiceClient.prototype.getSourcesTotals =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chatcontext.ChatContextService/GetSourcesTotals',
      request,
      metadata || {},
      methodDescriptor_ChatContextService_GetSourcesTotals,
      callback);
};


/**
 * @param {!proto.chatcontext.GetSourcesTotalsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chatcontext.GetSourcesTotalsResponse>}
 *     Promise that resolves to the response
 */
proto.chatcontext.ChatContextServicePromiseClient.prototype.getSourcesTotals =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chatcontext.ChatContextService/GetSourcesTotals',
      request,
      metadata || {},
      methodDescriptor_ChatContextService_GetSourcesTotals);
};


module.exports = proto.chatcontext;

